<mat-form-field appearance="outline" class="{{ class }}">
    @if (label) {
        <mat-label>{{ label }}</mat-label>
    }
    <input
        title="{{ title }}"
        type="tel"
        [showMaskTyped]="true"
        [specialCharacters]="specialCharacters"
        [dropSpecialCharacters]="dropSpecialCharacters"
        placeHolderCharacter="_"
        shownMaskExpression="{{ shownMaskExpression }}"
        mask="{{ mask }}"
        matInput
        [formControl]="control!"
    />
</mat-form-field>
